/** Unique work-order inventory locations for CM purchase order headers. */

export function uniqueWorkOrderLocationNames(
  workOrders: Array<{ location_name?: string | null }>,
): string[] {
  const seen = new Set<string>();
  const names: string[] = [];
  for (const workOrder of workOrders) {
    const name = (workOrder.location_name ?? "").trim();
    if (name === "" || seen.has(name)) {
      continue;
    }
    seen.add(name);
    names.push(name);
  }
  return names;
}

export function formatCmPoLocationSubtitle(
  purchaseOrderLocationName: string | null | undefined,
  workOrders: Array<{ location_name?: string | null }>,
): string {
  const parts: string[] = [];
  const shipTo = (purchaseOrderLocationName ?? "").trim();
  if (shipTo !== "") {
    parts.push(`Ship-to ${shipTo}`);
  }
  const workOrderNames = uniqueWorkOrderLocationNames(workOrders);
  if (workOrderNames.length > 0) {
    parts.push(`Work orders ${workOrderNames.join(", ")}`);
  }
  return parts.join(" · ");
}
